import { Injectable } from '@angular/core';

import { FirestorePathsService } from './firestorePaths.service';
import { FirestoreService } from '../lib/firestore.service';
import type { TUserAccountMap } from '@shared/models';

@Injectable({
    'providedIn': 'root'
})
export class UserAccountMapsService {
    constructor(private firestoreService: FirestoreService, private firestorePathsService: FirestorePathsService) {
    }

    public async getByUid(uid: string): Promise<TUserAccountMap> {
        const path = this.firestorePathsService.getUserAccountMapsPath();
        const doc = await this.firestoreService.getByUid(path, uid) as TUserAccountMap;
        if (doc) {
            return doc;
        } else {
            const err = new Error(`uid = ${uid} not found in userAccountMaps.`);
            throw err;
        }
    }

    public async getAll(): Promise<TUserAccountMap[]> {
        const path = this.firestorePathsService.getUserAccountMapsPath();
        return this.firestoreService.getAll(path) as Promise<TUserAccountMap[]>;
    }

    public async getByFieldValue(fieldName: string, fieldValue: string): Promise<TUserAccountMap[]> {
        const path = this.firestorePathsService.getUserAccountMapsPath();
        return this.firestoreService.getByFieldValue(path, fieldName, fieldValue) as Promise<TUserAccountMap[]>;
    }

    public async add(map: TUserAccountMap): Promise<TUserAccountMap> {
        const path = this.firestorePathsService.getUserAccountMapsPath();
        return this.firestoreService.set(path, map) as Promise<TUserAccountMap>;
    }

    public async set(map: TUserAccountMap, uid: string): Promise<TUserAccountMap> {
        map.uid = uid;
        const path = this.firestorePathsService.getUserAccountMapsPath();
        return this.firestoreService.set(path, map) as Promise<TUserAccountMap>;
    }

    public async update(map: TUserAccountMap): Promise<TUserAccountMap> {
        const collection = this.firestorePathsService.getUserAccountMapsPath();
        return this.firestoreService.update(collection, map) as Promise<TUserAccountMap>;
    }

    public async delete(uid: string): Promise<void> {
        const collection = this.firestorePathsService.getUserAccountMapsPath();
        return this.firestoreService.delete(collection, uid);
    }
}
